export const RULE_TYPES = [
  { value: 'quick_pill', label: 'Top search pill' },
  { value: 'midpage_pill', label: 'Mid-page search pill' },
  { value: 'dynamic_row', label: 'Dynamic row' },
  { value: 'event_row', label: 'Event row' },
  { value: 'provider_boost', label: 'Provider boost' },
  { value: 'game_boost', label: 'Game boost' },
  { value: 'promo_boost', label: 'Promotion boost' },
  { value: 'jackpot_rule', label: 'Jackpot rule' },
  { value: 'weekday_rule', label: 'Day/time rule' },
]

export const PLACEMENTS = [
  { value: 'top', label: 'Top of search' },
  { value: 'midpage', label: 'Mid-page strip' },
  { value: 'row', label: 'Search row' },
  { value: 'ranking', label: 'Ranking only' },
  { value: 'metadata', label: 'Metadata workflow' },
  { value: 'analytics', label: 'Analytics workflow' },
]

export const DEFAULT_PLACEMENT_BY_TYPE = {
  quick_pill: 'top',
  midpage_pill: 'midpage',
  dynamic_row: 'row',
  event_row: 'row',
  provider_boost: 'ranking',
  game_boost: 'ranking',
  promo_boost: 'ranking',
  jackpot_rule: 'ranking',
  weekday_rule: 'ranking',
}

export const RULE_KIND_CONFIG = {
  quick_pill: {
    label: 'Pill label',
    labelPlaceholder: 'Low vol + higher payout',
    queryLabel: 'Search phrase',
    queryPlaceholder: 'Search words players would use, e.g. low volatility slots',
    showQuery: true,
    showFilters: true,
    showTone: true,
  },
  midpage_pill: {
    label: 'Pill label',
    labelPlaceholder: 'Bonus rounds',
    queryLabel: 'Search phrase',
    queryPlaceholder: 'Search words players would use, e.g. free spins bonus buy',
    showQuery: true,
    showFilters: true,
    showTone: true,
    showAfterRows: true,
  },
  dynamic_row: {
    label: 'Row title',
    labelPlaceholder: 'High max win games',
    queryLabel: 'Find games matching',
    queryPlaceholder: 'Search words for this row, e.g. high max win slots',
    showQuery: true,
    showFilters: true,
    showTone: true,
    showSortStrategy: true,
  },
  event_row: {
    label: 'Row title',
    labelPlaceholder: "St. Patrick's Day picks",
    queryLabel: 'Find games matching',
    queryPlaceholder: 'Search words for this event, e.g. irish slots jackpot',
    showQuery: true,
    showFilters: true,
    showTone: true,
    showSortStrategy: true,
    showSchedule: true,
  },
  provider_boost: {
    label: 'Rule name',
    labelPlaceholder: 'Pragmatic Play campaign boost',
    showProvider: true,
    showBoost: true,
    showSchedule: true,
  },
  game_boost: {
    label: 'Rule name',
    labelPlaceholder: 'Featured game boost',
    showGameCodes: true,
    showBoost: true,
    showSchedule: true,
  },
  promo_boost: {
    label: 'Rule name',
    labelPlaceholder: 'Tournament promo boost',
    showPromo: true,
    showBoost: true,
    showSchedule: true,
    showPlacementChoice: true,
  },
  jackpot_rule: {
    label: 'Rule name',
    labelPlaceholder: 'Progressive jackpot lift',
    showJackpot: true,
    showBoost: true,
    showSchedule: true,
    showPlacementChoice: true,
  },
  weekday_rule: {
    label: 'Rule name',
    labelPlaceholder: 'Weekday low volatility mix',
    showWeekday: true,
    showFilters: true,
    showBoost: true,
    showSchedule: true,
  },
}

export const BOOST_RULE_TYPES = new Set(['provider_boost', 'game_boost', 'promo_boost', 'jackpot_rule', 'weekday_rule'])

export const VOLATILITY_OPTIONS = [
  { value: '', label: 'Any volatility' },
  { value: 'low', label: 'Low' },
  { value: 'medium-low', label: 'Medium-low' },
  { value: 'medium', label: 'Medium' },
  { value: 'medium-high', label: 'Medium-high' },
  { value: 'high', label: 'High' },
]

export const PAYOUT_OPTIONS = [
  { value: '', label: 'Any payout signal' },
  { value: '3', label: 'Good or better' },
  { value: '4', label: 'Strong or better' },
  { value: '5', label: 'Best only' },
]

export const TONE_OPTIONS = [
  { value: 'green', label: 'Green' },
  { value: 'blue', label: 'Blue' },
  { value: 'gold', label: 'Gold' },
  { value: 'orange', label: 'Orange' },
  { value: 'red', label: 'Red' },
  { value: 'teal', label: 'Teal' },
  { value: 'purple', label: 'Purple' },
  { value: 'pink', label: 'Pink' },
]

export const SORT_STRATEGY_OPTIONS = [
  { value: 'relevance', label: 'Most relevant' },
  { value: 'newest', label: 'Newest games' },
  { value: 'payout', label: 'Payout signal' },
  { value: 'max_win', label: 'Max win' },
  { value: 'jackpot_amount', label: 'Jackpot amount' },
  { value: 'provider_boost', label: 'Provider boost' },
]

export const JACKPOT_TYPE_OPTIONS = [
  { value: '', label: 'Any jackpot' },
  { value: 'progressive', label: 'Progressive' },
  { value: 'daily', label: 'Daily' },
  { value: 'must_drop', label: 'Must drop' },
]

export const PROMO_TYPE_OPTIONS = [
  { value: 'game_of_week', label: 'Game of week' },
  { value: 'free_spins', label: 'Free spins' },
  { value: 'tournament', label: 'Tournament' },
  { value: 'generic', label: 'Generic' },
]

export const PROMO_STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'enabled', label: 'Enabled' },
  { value: 'live', label: 'Live' },
  { value: 'draft', label: 'Draft' },
  { value: 'paused', label: 'Paused' },
  { value: 'expired', label: 'Expired' },
]

export const SOURCE_TYPE_OPTIONS = [
  { value: 'manual', label: 'Manual' },
  { value: 'csv', label: 'CSV' },
  { value: 'ftp', label: 'FTP' },
  { value: 'csp', label: 'CSP' },
]

export const SOURCE_STATUS_OPTIONS = [
  { value: 'active', label: 'Active' },
  { value: 'enabled', label: 'Enabled' },
  { value: 'live', label: 'Live' },
  { value: 'draft', label: 'Draft' },
  { value: 'paused', label: 'Paused' },
  { value: 'inactive', label: 'Inactive' },
]

export const JACKPOT_BEHAVIOR_OPTIONS = [
  { value: 'ranking', label: 'Boost ranking only' },
  { value: 'row', label: 'Create a search row' },
]

export const PAGE_COPY = {
  rules: {
    title: 'Rules',
    subtitle: 'Create search pills, rows, and ranking boosts for enabled iGaming search experiences.',
  },
  merchandising: {
    title: 'Merchandising',
    subtitle: 'Manage promotions and jackpot pools that rules can promote in search.',
  },
  data: {
    title: 'Data',
    subtitle: 'Review game metadata and track source ownership for iGaming search data.',
  },
  insights: {
    title: 'Search Insights',
    subtitle: 'Find search gaps and measure which rules drive engagement.',
  },
}

export const EMPTY_ANALYTICS_FILTERS = {
  market: '',
  device: '',
  from: '',
  to: '',
  rule_type: '',
  provider: '',
  theme: '',
}

export const DEFAULT_MERCHANDISING_TAB = 'promotions'
export const DEFAULT_DATA_TAB = 'metadata'

export const FIELD_HELP = {
  provider: 'One provider name. Spaces are OK, e.g. Pragmatic Play. Use Advanced JSON for more complex provider logic.',
  category: 'One category exactly as it appears in metadata. Spaces are OK, e.g. Live Dealer.',
  themes: 'Comma-separated themes. Multi-word themes stay within one comma item, e.g. lucky dragon, ancient egypt.',
  market: 'Optional market code. Leave blank to use this rule in every market.',
  segment: 'Optional player segment key. Leave blank to use this rule for every segment.',
  searchPhrase: 'Use normal search words or a phrase. Spaces are expected.',
}

export const DEFAULT_FORM = {
  id: null,
  rule_type: 'quick_pill',
  label: '',
  title: '',
  query: '',
  placement: 'top',
  sort_order: 10,
  market: '',
  segment: '',
  is_active: true,
  starts_at: '',
  ends_at: '',
  provider: '',
  game_codes: '',
  promo_type: '',
  jackpot_type: '',
  category: '',
  volatility: '',
  payout_level: '',
  max_win_min: '',
  theme_tags: '',
  weekday_days: '',
  time_start: '',
  time_end: '',
  tone: 'green',
  boost_strength: '1',
  sort_strategy: 'relevance',
  after_rows: '3',
  filter_logic: '{}',
  sort_logic: '{}',
  config: '{}',
}

export const DEFAULT_PROMO_FORM = {
  id: null,
  promo_id: '',
  name: '',
  promo_type: 'game_of_week',
  status: 'active',
  eligible_game_ids: '',
  priority: 10,
  market: '',
  segment: '',
  starts_at: '',
  ends_at: '',
  is_active: true,
}

export const DEFAULT_JACKPOT_FORM = {
  id: null,
  pool_id: '',
  jackpot_type: 'progressive',
  label: '',
  current_amount: '',
  currency: 'USD',
  participating_game_ids: '',
  must_drop_at: '',
  last_payout_at: '',
  market: '',
  segment: '',
  is_active: true,
}

export const DEFAULT_METADATA_FORM = {
  id: null,
  game_code: '',
  game_name: '',
  status: 'pending',
  themes: '',
  mechanics: '',
  volatility: '',
  payout_level: '',
  min_bet: '',
  max_bet: '',
  currency: 'USD',
  max_win_multiplier: '',
  source_notes: '',
  is_active: true,
}

export const DEFAULT_SOURCE_FORM = {
  id: null,
  name: '',
  source_type: 'manual',
  status: 'active',
  owner: '',
  mapping_notes: '',
  last_ingested_at: '',
  market: '',
  segment: '',
  is_active: true,
}

export const FRIENDLY_FILTER_KEYS = [
  'provider',
  'provider_name',
  'provider_inferred',
  'category',
  'categories',
  'volatility',
  'volatility_band',
  'payout_level',
  'max_win_min',
  'max_win_multiplier_min',
  'theme_tags',
  'game_code',
  'game_codes',
  'ids',
  'promo_type',
  'jackpot_type',
  'weekday_days',
  'time_start',
  'time_end',
]
